module.exports = __webpack_public_path__ + "media/images/best answer2-2a306044784b2daafbce7ead58d78786.svg";